const stripQueryParams = (route: string): string => {
  return route.split("?")[0];
};

export const useHashRoute = () => {
  if (typeof window === "undefined") return "unknown";

  const route = window.location.hash?.substring(1) || window.location.pathname || "unknown";
  return stripQueryParams(route);
};
